import { Box, Button, Container, Stack, Typography } from "@mui/material";
import TelegramIcon from "@mui/icons-material/Telegram";
import RuleIcon from "@mui/icons-material/Rule";
import { Link as RouterLink } from "react-router-dom";
import { MAIN_TELEGRAM_URL } from "utils/telegramGroups";

function FinalCTA() {
  return (
    <Box component="section" sx={{ py: { xs: 8, md: 12 } }}>
      <Container maxWidth="md">
        <Box
          sx={{
            position: "relative",
            overflow: "hidden",
            borderRadius: 4,
            p: { xs: 4, md: 8 },
            textAlign: "center",
            background:
              "linear-gradient(131.35deg, #cb97ff 7.53%, #583dff 94.2%)",
            color: "#fff",
            boxShadow: "0 30px 60px -25px rgba(88,61,255,0.45)",
          }}
        >
          <Typography
            component="h2"
            sx={{
              fontSize: { xs: 28, md: 40 },
              fontWeight: 900,
              lineHeight: 1.2,
              mb: 2,
            }}
          >
            Bereit für deine Community?
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 15, md: 17 },
              lineHeight: 1.6,
              maxWidth: 560,
              mx: "auto",
              mb: 4,
              color: "rgba(255,255,255,0.92)",
            }}
          >
            Tritt der Hauptgruppe bei und stell dich kurz vor. Wir freuen uns,
            wenn du dabei bist.
          </Typography>
          <Stack
            direction={{ xs: "column", sm: "row" }}
            spacing={2}
            justifyContent="center"
          >
            <Button
              variant="contained"
              size="large"
              startIcon={<TelegramIcon />}
              href={MAIN_TELEGRAM_URL}
              target="_blank"
              rel="noopener"
              sx={{
                px: 4,
                py: 1.5,
                fontWeight: 700,
                textTransform: "none",
                fontSize: 16,
                background: "#fff",
                color: "#583dff",
                "&:hover": { background: "#f1eef8" },
              }}
            >
              Jetzt beitreten
            </Button>
            <Button
              variant="outlined"
              size="large"
              startIcon={<RuleIcon />}
              component={RouterLink}
              to="/network-it-rules"
              sx={{
                px: 4,
                py: 1.5,
                fontWeight: 700,
                textTransform: "none",
                fontSize: 16,
                color: "#fff",
                borderColor: "rgba(255,255,255,0.7)",
                "&:hover": {
                  borderColor: "#fff",
                  background: "rgba(255,255,255,0.08)",
                },
              }}
            >
              Community-Regeln
            </Button>
          </Stack>
        </Box>
      </Container>
    </Box>
  );
}

export default FinalCTA;
